// Visualization2 CP-1B Page - Hardcoded Configuration
import React, { useState, useEffect, useCallback } from 'react';
import { Header } from '../components/Header';
import { useAuthContext as useAuth } from '../contexts/AuthContext';
import { permissionChecks } from '../lib/auth/helpers';
import { CPConfig, SequenceConfig } from '../types/config';
import { VisualizationEngine } from '../components/visualization/VisualizationEngine';
import { thresholdService, ThresholdServiceStatic } from '../services/thresholdService';
import { OccupancyServiceStatic } from '../services/occupancyService';

// CP-1B Configuration from JSON - Redesigned (29x45 grid, bottom to top flow)
const cp1bConfig: CPConfig = {
  grids: {
    x: 29,
    y: 45
  },
  assets: {
    metaldetectors: [
      { x: 6, y: 27.5 },
      { x: 14.5, y: 31 }
    ],
    bodyscanner: [
      { x: 4.5, y: 29 },
      { x: 12, y: 31.5 }
    ],
    conveyorbelt: [
      { start: { x: 3, y: 21 }, end: { x: 3, y: 36 } },
      { start: { x: 8, y: 26 }, end: { x: 8, y: 36 } },
      { start: { x: 11.5, y: 28 }, end: { x: 11.5, y: 36 } },
      { start: { x: 15.5, y: 28 }, end: { x: 15.5, y: 36 } }
    ]
  },
  heatmap: {
    "t1-1b_s2_a01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Business"],
      tagLabel: [
  {
    "text": "Business",
    "start": {"x": 22.5, "y": 2.5},
    "end": {"x": 27.5, "y": 2.5},
  }
],  
      polygon: [
        { x: 0.5, y: 19 },
        { x: 1.5, y: 19 },
        { x: 1.5, y: 8.5 },
        { x: 15, y: 8.5 },
        { x: 15, y: 3 },
        { x: 22.5, y: 3 },
        { x: 22.5, y: 2 },
        { x: 14, y: 2 },
        { x: 14, y: 7.5 },
        { x: 0.5, y: 7.5 }
      ],
      passengerPath: [
        { x: 22, y: 2.5 },
        { x: 20, y: 2.5 },
        { x: 18, y: 2.5 },
        { x: 16, y: 2.5 },
        { x: 14.5, y: 2.5 },
        { x: 14.5, y: 4.5 },
        { x: 14.5, y: 6.5 },
        { x: 14.5, y: 7.5 },
        { x: 14.5, y: 8 },
        { x: 12, y: 8 },
        { x: 10, y: 8 },
        { x: 8, y: 8 },
        { x: 6, y: 8 },
        { x: 4, y: 8 },
        { x: 2, y: 8 },
        { x: 1, y: 8 },
        { x: 1, y: 11 },
        { x: 1, y: 13 },
        { x: 1, y: 15 },
        { x: 1, y: 17 },
        { x: 1, y: 19 }
      ]
    },
    "t1-1b_s2_a02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Standard"],
      tagLabel: [
  {
    "text": "Standard",
    "start": {"x": 22.5, "y": 3.5},
    "end": {"x": 27.5, "y": 3.5},
  }
],  
      polygon: [
        { x: 1.5, y: 19 },
        { x: 7.5, y: 19 },
        { x: 7.5, y: 15.5 },
        { x: 8.5, y: 12 },
        { x: 16, y: 12 },
        { x: 16, y: 4 },
        { x: 22.5, y: 4 },
        { x: 22.5, y: 3 },
        { x: 15, y: 3 },
        { x: 15, y: 8.5 },
        { x: 1.5, y: 8.5 }
      ],
      passengerPath: [
        { x: 22, y: 3.5 },
        { x: 20, y: 3.5 },
        { x: 18, y: 3.5 },
        { x: 15.5, y: 3.5 },
        { x: 15.5, y: 4.5 },
        { x: 15.5, y: 6.5 },
        { x: 15.5, y: 7.5 },
        { x: 15.5, y: 9 },
        { x: 15.5, y: 10 },
        { x: 10, y: 10 },
        { x: 8, y: 10 },
        { x: 6, y: 10 },
        { x: 4, y: 10 },
        { x: 4, y: 13 },
        { x: 4, y: 15 },
        { x: 4, y: 17 },
        { x: 4, y: 19 }
      ]
    },
    "t1-1b_s2_a03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Clear"],
      tagLabel: [
  {
    "text": "Clear",
    "start": {"x": 22.5, "y": 4.5},
    "end": {"x": 27.5, "y": 4.5},
  }
],  
      polygon: [
        { x: 7.5, y: 19 },
        { x: 9.5, y: 19 },
        { x: 9.5, y: 15 },
        { x: 9.2, y: 13 },
        { x: 17, y: 13 },
        { x: 17, y: 5 },
        { x: 22.5, y: 5 },
        { x: 22.5, y: 4 },
        { x: 16, y: 4 },
        { x: 16, y: 12 },
        { x: 8.5, y: 12 },
        { x: 7.5, y: 15.5 }
      ],
      passengerPath: [
        { x: 22, y: 4.5 },
        { x: 20, y: 4.5 },
        { x: 18, y: 4.5 },
        { x: 16.5, y: 4.5 },
        { x: 16.5, y: 6.5 },
        { x: 16.5, y: 7.5 },
        { x: 16.5, y: 9 },
        { x: 16.5, y: 10 },
        { x: 16.5, y: 11 },
        { x: 16.5, y: 12.5 },
        { x: 15, y: 12.5 },
        { x: 13.5, y: 12.5 },
        { x: 12, y: 12.5 },
        { x: 10, y: 12.5 },
        { x: 8.75, y: 12.5 },
        { x: 8.75, y: 14 },
        { x: 8.75, y: 16 },
        { x: 8.75, y: 18 },
        { x: 8.75, y: 19 }
      ]
    },
    "t1-1b_s2_a04": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["Crew"],
      tagLabel: [
  {
    "text": "Crew",
    "start": {"x": 22.5, "y": 5.5},
    "end": {"x": 27.5, "y": 5.5},
  }
],  
      polygon: [
        { x: 10.5, y: 19 },
        { x: 10.5, y: 14 },
        { x: 18, y: 14 },
        { x: 18, y: 6 },
        { x: 22.5, y: 6 },
        { x: 22.5, y: 5 },
        { x: 17, y: 5 },
        { x: 17, y: 13 },
        { x: 9.2, y: 13 },
        { x: 9.5, y: 15 },
        { x: 9.5, y: 19 }
      ],
      passengerPath: [
        { x: 22, y: 5.5 },
        { x: 20, y: 5.5 },
        { x: 17.5, y: 5.5 },
        { x: 17.5, y: 6.5 },
        { x: 17.5, y: 7.5 },
        { x: 17.5, y: 9 },
        { x: 17.5, y: 10 },
        { x: 17.5, y: 12 },
        { x: 17.5, y: 13.5 },
        { x: 15, y: 13.5 },
        { x: 13.5, y: 13.5 },
        { x: 12, y: 13.5 },
        { x: 10, y: 13.5 },
        { x: 10, y: 14 },
        { x: 10, y: 16 },
        { x: 10, y: 18 },
        { x: 10, y: 19 }
      ]
    },
    "t1-1b_s2_a05": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: ["TSA Precheck"],
      tagLabel: [
  {
    "text": "TSA Precheck",
    "start": {"x": 22.5, "y": 6.5},
    "end": {"x": 27.5, "y": 6.5},
  }
],  
      polygon: [
        { x: 11.5, y: 19 },
        { x: 11.5, y: 15 },
        { x: 19, y: 15 },
        { x: 19, y: 7 },
        { x: 22.5, y: 7 },
        { x: 22.5, y: 6 },
        { x: 18, y: 6 },
        { x: 18, y: 14 },
        { x: 10.5, y: 14 },
        { x: 10.5, y: 19 }
      ],
      passengerPath: [
        { x: 22, y: 6.5 },
        { x: 20, y: 6.5 },
        { x: 18.5, y: 6.5 },
        { x: 18.5, y: 7.5 },
        { x: 18.5, y: 9 },
        { x: 18.5, y: 10 },
        { x: 18.5, y: 12 },
        { x: 18.5, y: 14.5 },
        { x: 17, y: 14.5 },
        { x: 15.5, y: 14.5 },
        { x: 13, y: 14.5 },
        { x: 12, y: 14.5 },
        { x: 11, y: 14.5 },
        { x: 11, y: 16 },
        { x: 11, y: 18 },
        { x: 11, y: 19 }
      ]
    },
    "t1-1b_s1-1_z01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 4, y: 22 },
        { x: 5.5, y: 22 },
        { x: 5.5, y: 27 },
        { x: 4, y: 27 }
      ],
      passengerPath: [
        { x: 4.75, y: 22 },
        { x: 4.75, y: 23 },
        { x: 4.75, y: 24 },
        { x: 4.75, y: 25 },
        { x: 4.75, y: 26 },
        { x: 4.75, y: 27 }
      ]
    },
    "t1-1b_s1-2_z01": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 4, y: 30 },
        { x: 5.5, y: 30 },
        { x: 5.5, y: 36 },
        { x: 4, y: 36 }
      ],
      passengerPath: [
        { x: 4.75, y: 30 },
        { x: 4.75, y: 31 },
        { x: 4.75, y: 32 },
        { x: 4.75, y: 33 },
        { x: 4.75, y: 34 },
        { x: 4.75, y: 35 },
        { x: 4.75, y: 36 }
      ]
    },
    "t1-1b_s1-1_z02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 5.5, y: 22 },
        { x: 7, y: 22 },
        { x: 7, y: 27 },
        { x: 5.5, y: 27 }
      ],
      passengerPath: [
        { x: 6.25, y: 22 },
        { x: 6.25, y: 23 },
        { x: 6.25, y: 24 },
        { x: 6.25, y: 25 },
        { x: 6.25, y: 26 },
        { x: 6.25, y: 27 }
      ]
    },
    "t1-1b_s1-2_z02": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 5.5, y: 30 },
        { x: 7, y: 30 },
        { x: 7, y: 36 },
        { x: 5.5, y: 36 }
      ],
      passengerPath: [
        { x: 6.25, y: 30 },
        { x: 6.25, y: 31 },
        { x: 6.25, y: 32 },
        { x: 6.25, y: 33 },
        { x: 6.25, y: 34 },
        { x: 6.25, y: 35 },
        { x: 6.25, y: 36 }
      ]
    },
    "t1-1b_s1-1_z03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 12.5, y: 26 },
        { x: 14, y: 26 },
        { x: 14, y: 31 },
        { x: 12.5, y: 31 }
      ],
      passengerPath: [
        { x: 13.25, y: 26 },
        { x: 13.25, y: 27 },
        { x: 13.25, y: 28 },
        { x: 13.25, y: 29 },
        { x: 13.25, y: 30 },
        { x: 13.25, y: 31 }
      ]
    },
    "t1-1b_s1-2_z03": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 12.5, y: 34 },
        { x: 14, y: 34 },
        { x: 14, y: 40 },
        { x: 12.5, y: 40 }
      ],
      passengerPath: [
        { x: 13.25, y: 34 },
        { x: 13.25, y: 35 },
        { x: 13.25, y: 36 },
        { x: 13.25, y: 37 },
        { x: 13.25, y: 38 },
        { x: 13.25, y: 39 },
        { x: 13.25, y: 40 }
      ]
    },
    "t1-1b_s1-1_z04": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 14, y: 25 },
        { x: 15.5, y: 25 },
        { x: 15.5, y: 31 },
        { x: 14, y: 31 }
      ],
      passengerPath: [
        { x: 14.75, y: 25 },
        { x: 14.75, y: 26 },
        { x: 14.75, y: 27 },
        { x: 14.75, y: 28 },
        { x: 14.75, y: 29 },
        { x: 14.75, y: 30 },
        { x: 14.75, y: 31 }
      ]
    },
    "t1-1b_s1-2_z04": {
      green: 20, yellow: 25, amber: 30,
      minflow: 5, maxflow: 20,
      tag: [],
      polygon: [
        { x: 14, y: 34 },
        { x: 15.5, y: 34 },
        { x: 15.5, y: 40 },
        { x: 14, y: 40 }
      ],
      passengerPath: [
        { x: 14.75, y: 34 },
        { x: 14.75, y: 35 },
        { x: 14.75, y: 36 },
        { x: 14.75, y: 37 },
        { x: 14.75, y: 38 },
        { x: 14.75, y: 39 },
        { x: 14.75, y: 40 }
      ]
    }
  },
  metadata: {
    checkpointId: "cp-1b",
    name: "Checkpoint 1B",
    terminal: "T1-1B",
    gridUnit: "meter",
    description: "Security checkpoint layout with multiple lanes and processing areas"
  }
};
// Updated sequence config for redesigned visualization
const sequenceConfig: SequenceConfig = {
  layerSequence: {
    description: "Layer rendering sequence configuration - Grid → Heatmap Polygons → Assets",
    layers: {
      "1": { name: "Base Grid", description: "Grid lines and coordinates", enabled: true, zIndex: 1 },
      "2": { name: "Heatmap Polygons", description: "Filled polygon areas with occupancy colors", enabled: true, zIndex: 2 },
      "3": { name: "Assets", description: "Metal detectors, body scanners, conveyor belts", enabled: true, zIndex: 3 }
    }
  },
  renderingOptions: {
    enableLayerToggle: false,
    defaultVisibleLayers: ["1", "2", "3"],
    animationSpeed: 1000
  }
};

// Mock occupancy data removed - using live API data only

export const Visualization2CP1BPage: React.FC = () => {
  const { user } = useAuth();
  const [currentOccupancyData, setCurrentOccupancyData] = useState<Record<string, number> | null>(null);
  const [currentFlowData, setCurrentFlowData] = useState<Record<string, number> | null>(null);
  const [apiThresholds, setApiThresholds] = useState<Record<string, { green: number; yellow: number; amber: number; minflow: number; maxflow: number }> | null>(null);
  const [isLoadingThresholds, setIsLoadingThresholds] = useState(false);
  const [thresholdLoadError, setThresholdLoadError] = useState<string | null>(null);
  const [thresholdSource, setThresholdSource] = useState<'api' | 'cache' | 'default'>('default');
  const [occupancyError, setOccupancyError] = useState<string | null>(null);
  const [isLoadingOccupancy, setIsLoadingOccupancy] = useState(true);

  // Check 2D view permission
  const hasAccess = permissionChecks.can2dVisualisationAccess();

  // Subscribe to occupancy data updates
  useEffect(() => {
    // Start periodic fetch
    OccupancyServiceStatic.startPeriodicFetch();
    
    // Subscribe to data updates
    const unsubscribe = OccupancyServiceStatic.subscribe((data, error) => {
      if (data) {
        setCurrentOccupancyData(data.occupancy);
        setCurrentFlowData(data.flowOut);
        setIsLoadingOccupancy(false);
        setOccupancyError(null);
      } else if (error) {
        setOccupancyError(error);
        if (!OccupancyServiceStatic.hasData()) {
          setIsLoadingOccupancy(false);
        }
        console.error('CP-1B: Occupancy error:', error);
      }
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  // Updated threshold fetching with automatic refresh
  const fetchThresholds = async (isAutoRefresh = false) => {
    if (!isAutoRefresh) {
      setIsLoadingThresholds(true);
    }
    setThresholdLoadError(null);
    
    try {
      const thresholds = await thresholdService.getThresholds();
      
      // Filter for CP-1B thresholds only
      const cp1bThresholds = Object.fromEntries(
        Object.entries(thresholds).filter(([assetCode]) => assetCode.startsWith('t1-1b_'))
      );
      
      setApiThresholds(cp1bThresholds);
      
      // Determine source for status display
      const cached = ThresholdServiceStatic.getCachedThresholds();
      if (cached && Object.keys(cached).length > 0) {
        setThresholdSource('cache');
      } else if (Object.keys(cp1bThresholds).length > 0) {
        setThresholdSource('api');
      } else {
        setThresholdSource('default');
      }
      
      // Thresholds loaded successfully
      
    } catch (error) {
      console.error('Failed to load thresholds:', error);
      setThresholdLoadError('Failed to load threshold configuration');
      setThresholdSource('default');
      setApiThresholds(null);
    } finally {
      if (!isAutoRefresh) {
        setIsLoadingThresholds(false);
      }
    }
  };

  // Auto-refresh callback for periodic updates
  const handleAutoRefresh = useCallback((thresholds: any) => {
    console.log('CP-1B: Auto-refresh triggered');
    fetchThresholds(true); // Silent refresh
  }, []);

  // Load thresholds on mount and start periodic refresh
  useEffect(() => {
    fetchThresholds();
    
    // Start automatic refresh with callback
    ThresholdServiceStatic.startPeriodicRefresh(handleAutoRefresh);
    
    // Cleanup on unmount
    return () => {
      ThresholdServiceStatic.stopPeriodicRefresh();
    };
  }, [handleAutoRefresh]);
  // If no access, show permission denied
  if (!hasAccess) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Access Denied</h1>
          <p className="text-gray-400">You don't have permission to access 2D View features.</p>
          <p className="text-gray-500 text-sm mt-2">Required permission: 2d_visualisation_access</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 relative bg-gray-900">
      {/* Local loading indicator for thresholds */}
      {isLoadingThresholds && (
        <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-2 rounded-md text-sm z-10">
          Loading thresholds...
        </div>
      )}
      
      {/* Loading indicator for occupancy data */}
      {isLoadingOccupancy && (
        <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-2 rounded-md text-sm z-10">
          Loading occupancy data...
        </div>
      )}
      
      {/* Threshold error indicator */}
      {thresholdLoadError && (
        <div className="absolute top-4 left-4 bg-yellow-600 text-white px-3 py-2 rounded-md text-sm z-10">
          {thresholdLoadError} - Using defaults
        </div>
      )}
      
      {/* Occupancy error indicator */}
      {occupancyError && (
        <div className="absolute top-4 right-4 bg-orange-600 text-white px-3 py-2 rounded-md text-sm z-10">
          Data connection issues
        </div>
      )}

      <VisualizationEngine
        checkpointConfig={cp1bConfig}
        sequenceConfig={sequenceConfig}
        occupancyData={currentOccupancyData}
        flowData={currentFlowData}
        thresholds={apiThresholds || undefined}
        checkpointId="cp-1b"
        className="w-full h-full"
      />
    </div>
  );
};